// Only `totalRecords` is retained, never `results.length`: the request is deliberately capped to a
// single row, `results` is not read at all.
export type PasswordSignInUserCountPayload = {
	readonly passwordSignInUserCount: number;
};

export type PasswordSignInUserCountFetchedAction = {
	type: 'PASSWORD_SIGN_IN_USER_COUNT_FETCHED';
	payload: PasswordSignInUserCountPayload;
	accountId: number;
};

export default (
	payload: PasswordSignInUserCountPayload,
	accountId: number,
): PasswordSignInUserCountFetchedAction => ({
	type: 'PASSWORD_SIGN_IN_USER_COUNT_FETCHED',
	payload,
	accountId,
});
